const TENANT_ID_KEY = 'dojopro:tenant_id'
// Access token in sessionStorage: per-tab, cleared on window close, captured by
// Playwright storageState so E2E workers don't need to call /auth/refresh on every
// page load (which causes token rotation conflicts with parallel workers).
// Security tradeoff vs pure memory: XSS within the tab could read it, but the
// refresh_token (which grants persistence) stays safe in httpOnly cookie.
const ACCESS_TOKEN_KEY = 'dojopro:access_token'

// Legacy keys — used only in clearAll() to purge old storage entries after migration
const LEGACY_ACCESS_TOKEN_KEY = 'dojopro:token'
const LEGACY_REFRESH_TOKEN_KEY = 'dojopro:refresh_token'
const LEGACY_TENANT_ID_KEY = 'dojopro:tenant_id'

// In-memory mirror for synchronous reads within the same JS context (avoids
// repeated sessionStorage.getItem calls in hot paths like request interceptors)
let _accessToken: string | null = null

export const storage = {
  getToken: () => _accessToken ?? sessionStorage.getItem(ACCESS_TOKEN_KEY),
  setToken: (token: string) => {
    _accessToken = token
    sessionStorage.setItem(ACCESS_TOKEN_KEY, token)
  },
  removeToken: () => {
    _accessToken = null
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  },

  // Tenant ID in sessionStorage (per-tab, not accessible cross-origin)
  getTenantId: () => sessionStorage.getItem(TENANT_ID_KEY),
  setTenantId: (tenantId: string) => sessionStorage.setItem(TENANT_ID_KEY, tenantId),
  removeTenantId: () => sessionStorage.removeItem(TENANT_ID_KEY),

  clearAll: () => {
    _accessToken = null
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
    sessionStorage.removeItem(TENANT_ID_KEY)
    // Clean up legacy localStorage keys from before cookie/memory migration
    localStorage.removeItem(LEGACY_ACCESS_TOKEN_KEY)
    localStorage.removeItem(LEGACY_REFRESH_TOKEN_KEY)
    localStorage.removeItem(LEGACY_TENANT_ID_KEY)
  },
}
